import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  NgbModal,
  NgbActiveModal,
  ModalDismissReasons,
  NgbPanelChangeEvent,
  NgbAccordion,
} from '@ng-bootstrap/ng-bootstrap';

import {
  AlertService,
  GrowlType,
} from '../../../infrastructure/services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';
import { Language } from 'app/infrastructure/model/classes/resource.class';

const EXCEL_FORMAT = 'EXCEL';
const JSON_FORMAT  = 'JSON'; 

@Component({
  selector: 'sx-import-modal',
  templateUrl: 'importModal.component.html',
  styleUrls: ['importModal.css'],
})
export class ImportModalComponent implements OnInit{
  @Input() isCustom;
  @Input() codOrganization;
  @Input() codSuscription;
  @Input() codChannel;

  fileFortmat:string = EXCEL_FORMAT;
  file: any;
  fileExtension:string;
  fileToImport: any;

  excelExtension:string[] = ['xls', 'xlsx'];
  jsonExtenion:string[] = ['json'];
  acceptedExrension:string[] = [];

  languages: Language[];
  selectedLanguage: Language;

  warningMessage: string = '';
  processResultMessage: string = '';

  constructor(
    private modal: NgbModal,
    private activeModal: NgbActiveModal,
    private alertService: AlertService,
    private router: Router,
    private route: ActivatedRoute,
    private sxTranslationService: SxTranslationService
  ) {}

  ngOnInit(): void {
    this.sxTranslationService.getAllLanguages()
    .then(response => {
      this.languages = response.result;
    });

    this.acceptedExrension = this.excelExtension.concat(this.jsonExtenion);
  }

  confirmar() {
    this.activeModal.close();
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  onItemChange(value){
    this.fileFortmat = value;
 }

 canImport(){

  if(this.file == null){
    this.warningMessage = this.sxTranslationService.getResource('SOC_IMP_EXP_0001_SELECT_FILE');
    return false;
  }

  if(this.fileFortmat == EXCEL_FORMAT && this.excelExtension.indexOf(this.fileExtension) < 0){
    this.warningMessage = this.sxTranslationService.getResource('SOC_IMP_EXP_0002_VALID_EXCEL_FILE');
    return false;
  }

  if(this.fileFortmat == JSON_FORMAT && this.jsonExtenion.indexOf(this.fileExtension) < 0){
    this.warningMessage = this.sxTranslationService.getResource('SOC_IMP_EXP_0003_VALID_JSON_FILE');
    return false;
  }

  if(this.fileFortmat == EXCEL_FORMAT && this.selectedLanguage == null ){
    this.warningMessage = this.sxTranslationService.getResource('SOC_IMP_EXP_0004_SELECT_LANGUAGE');
    return false;
  }

  return true;
 }

 onFileChange(event) {

  const fileSelected = event.target.files && event.target.files.length > 0;

  if (fileSelected) {
    const reader = new FileReader();
    const file = event.target.files[0];
    this.file = file;
    this.fileExtension = file.name ? file.name.split('.').pop() : '';

    if (this.acceptedExrension.indexOf(this.fileExtension) < 0) {
      return;
    }

    if( this.excelExtension.indexOf( this.fileExtension ) > 0 )
      reader.readAsDataURL(file);
    else
      reader.readAsBinaryString(file);

    reader.onload = (e: any) => {
      
      if( this.excelExtension.indexOf( this.fileExtension ) > 0 )
        this.fileToImport = e.target.result.replace(/^data:application\/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,/, ''); 
      else
        this.fileToImport = e.target.result;
    };
  }
}

import(){

    switch ( this.fileFortmat ) {
      case EXCEL_FORMAT:
        let culture = this.selectedLanguage.culture;
        
        let urlExcel =  this.sxTranslationService.import(this.isCustom, this.fileToImport, culture, this.codOrganization, this.codSuscription, this.codChannel)
        .then(response => {
          this.processResultMessage  = response? this.sxTranslationService.getResource('SOC_IMP_EXP_0005_PROCESS_OK') : 
                                                 this.sxTranslationService.getResource('SOC_IMP_EXP_0006_PROCESS_KO')
        });
       break;
      case JSON_FORMAT:
        let urlJSON =  this.sxTranslationService.deserialize(this.isCustom, JSON.parse(this.fileToImport), this.codOrganization, this.codSuscription, this.codChannel)
        .then(response => {
          this.processResultMessage  = response? this.sxTranslationService.getResource('SOC_IMP_EXP_0005_PROCESS_OK') : 
                                                 this.sxTranslationService.getResource('SOC_IMP_EXP_0006_PROCESS_KO')
        });
      break;
      default:
      break;
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/importModal/importModal.component.ts